import { shouldShowRscLibp } from "@faire/deprecated-retailer-visitor-shared/views/brand/utils/shouldShowRscLibp";
import { Path } from "@faire/web/common/Path";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useThrottledScrollToShopSection } from "./hooks/useThrottledScrollToShopSection";

export const useSearchHandler = () => {
  const history = useHistory();

  const scrollToSection = useThrottledScrollToShopSection();
  const handleSearch = useCallback(
    (query: string, refType?: string, refReqId?: string) => {
      scrollToSection();

      const path = new Path({
        pathname: history.location.pathname,
        search: "",
      });

      if (shouldShowRscLibp()) {
        path.append({ fc: "true" });
      }

      if (query) {
        path.append({ q: query });
      }
      if (refType) {
        path.append({ refType: refType });
      }
      if (refReqId) {
        path.append({ refReqId: refReqId });
      }

      history.push(path.toString());
    },
    [scrollToSection, history]
  );

  return handleSearch;
};
